import { Engine, Scene, ArcRotateCamera, Color3, Constants,HemisphericLight, Vector3, WebGPUEngine } from '@babylonjs/core';
import { Tool } from '../utils/tools';
import { GlobalObject } from './../utils/GlobalObject';
export class World {
  private _canvas: HTMLCanvasElement;
  // babylon
  private _engine?: Engine | WebGPUEngine;
  private _scene!: Scene;
  private _camera!: ArcRotateCamera;
  public scene!: Scene;
  public camera!: ArcRotateCamera;
  public loopFuncMap: any = new Map(); //将要每一帧都运行的在doRender的函数加到这个数组里面。


  constructor(canvasElement: HTMLCanvasElement) {
    this._canvas = canvasElement;
    //this.init();
  }
  public async init() {
    this._engine = await this.createEngine() as any;
    if (this._engine) {
      this._engine.disableVertexArrayObjects = false;
      this.createScene();
      this.doRender();
    }
  }
  private async createEngine(): Promise<WebGPUEngine | Engine> {
    const webGPUSupported = await (WebGPUEngine as any).IsSupportedAsync;
    console.log("webGPUSupported:" + webGPUSupported);
    GlobalObject.getInstance().main.temp.isWebGPU = webGPUSupported;
    if (webGPUSupported) {
      const engine = new WebGPUEngine(this._canvas);
      await engine.initAsync();
      engine.snapshotRenderingMode = Constants.SNAPSHOTRENDERING_FAST;
      // engine.snapshotRendering = true;
      GlobalObject.getInstance().main.temp.isWebGPU = true;
      return engine;
    }
    return new Engine(this._canvas, true);
  }
  private async createScene() {
    console.log("====== createScene!!! =======");
    // 设置场景
    this._scene = new Scene(this._engine as (WebGPUEngine | Engine));
    this._scene.ambientColor = new Color3(1, 1, 1);
    this.scene = this._scene;
    // 设置camera
    let cameraRectRatio = 1;
    if (Tool.osType() != 'pc') {
      cameraRectRatio = 0.5;
    }
    this._camera = new ArcRotateCamera('arcCamera1', 0.5 * Math.PI, 0.5 * Math.PI, 0.2, new Vector3(0, 0.3, 0), this.scene);
    this.initCamera(this._camera);
    this.camera = this._camera;
    this._camera.attachControl(this._canvas, false);

    window.addEventListener('resize', this.onWindowResize.bind(this), false);
  }
  private initCamera(camera: ArcRotateCamera) {
    camera.setPosition(new Vector3(20, 3, 0));
    camera.fov = 0.45 * Math.PI;
    camera.minZ = 1;
    camera.maxZ = 12000;
    camera.wheelPrecision = 30;  // 鼠标缩放速度放慢20倍
    camera.keysLeft = [] // key code
    camera.keysRight = []
    camera.keysUp = []
    camera.keysDown = []
    // 半径
    camera.lowerRadiusLimit = 0.8;
    camera.upperRadiusLimit = 1.1 * 120;
    // camera俯仰角度限制,设置beta的范围限制 顶部是0PI,水平是0.5PI
    camera.lowerBetaLimit = Math.PI * 0.0;  // 顶部
    camera.upperBetaLimit = Math.PI * 0.53; // 水平
    // 水平旋转camera的速度
    camera.angularSensibilityX = 2000;
  }
  private runloopFuncMap() {
    this.loopFuncMap.forEach((value: any, key: any) => {
      value();
    });
  }
  //resize
  private onWindowResize() {
    this._canvas.style.width = '100%';
    this._canvas.style.height = '100%';
    (this._engine as (WebGPUEngine | Engine)).resize();
  }
  // render
  private doRender(): void {
    (this._engine as (WebGPUEngine | Engine)).runRenderLoop(() => {
      // this.runloopFuncMap();
      if (this._scene) {
        this._scene.render();
      }
    });
  }
}
